import type {
  MovableWorkspace,
  UpdateWorkspaceInput,
  UpdateWorkspaceRegistrantInput,
  WorkspaceProject,
  WorkspaceRegistrantResponse,
  WorkspaceSettings,
} from "schemas/generated/bedrock";
import type { FindDomainsOutput } from "schemas/generated/domainRegistration";
import type { RequestFn } from "./request";

export function createWorkspacesClient({ request }: { request: RequestFn }) {
  return {
    get: ({ workspaceId }: { workspaceId: string }) => {
      return request<WorkspaceSettings>({
        method: "GET",
        path: `/api/v1/workspaces/${encodeURIComponent(workspaceId)}`,
      });
    },
    getRegistrant: ({ workspaceId }: { workspaceId: string }) => {
      return request<WorkspaceRegistrantResponse>({
        method: "GET",
        path: `/api/v1/workspaces/${encodeURIComponent(workspaceId)}/registrant`,
      });
    },
    findDomainRegistrations: ({ workspaceId }: { workspaceId: string }) => {
      return request<FindDomainsOutput>({
        method: "GET",
        path: `/api/v1/workspaces/${encodeURIComponent(workspaceId)}/domain-registrations`,
      });
    },
    updateRegistrant: ({
      workspaceId,
      ...input
    }: UpdateWorkspaceRegistrantInput & { workspaceId: string }) => {
      return request<WorkspaceRegistrantResponse>({
        method: "PUT",
        path: `/api/v1/workspaces/${encodeURIComponent(workspaceId)}/registrant`,
        body: input,
      });
    },
    find: () => {
      return request<MovableWorkspace[]>({
        method: "GET",
        path: "/api/v1/workspaces/movable",
      });
    },
    findProjects: (input: { workspaceId: string }) => {
      return request<WorkspaceProject[]>({
        method: "GET",
        path: "/api/v1/workspaces/projects",
        query: { workspaceId: input.workspaceId },
      });
    },
    update: ({
      workspaceId,
      update,
    }: {
      workspaceId: string;
      update: UpdateWorkspaceInput;
    }) => {
      return request<WorkspaceSettings>({
        method: "PATCH",
        path: `/api/v1/workspaces/${encodeURIComponent(workspaceId)}`,
        body: update,
      });
    },
    delete: ({ workspaceId }: { workspaceId: string }) => {
      return request<{ success: boolean }>({
        method: "DELETE",
        path: `/api/v1/workspaces/${encodeURIComponent(workspaceId)}`,
      });
    },
  };
}
